import axios from 'axios';
import {
  loginRequestDataType,
  verifyElegibilityDataType,
} from 'store/user/types';
import { getApiBaseUrl } from 'helpers/api';
import axiosInstance from 'utils/axiosInstance';

const baseUrl = getApiBaseUrl();

type EmailSubsciptionType = {
  email: string;
  token: string;
  language: string;
};

type EmailVerificationType = {
  pin: string;
  token: string;
};
export function userLogin(data: loginRequestDataType) {
  return axios.post(`${baseUrl}/user/login`, data);
}

export function verifyElegibility(data: verifyElegibilityDataType) {
  return axios.post(`${baseUrl}/user/verifyElegibility`, data);
}

export function sendLoginViaMailOnboarding({
  email,
  login,
  token,
  language,
}: {
  email: string;
  login: string;
  token: string;
  language: string;
}) {
  return axios.post(
    `${baseUrl}/user/sendLoginViaMail/${login}`,
    {
      token,
      email,
      login,
    },
    {
      params: {
        email,
        language,
      },
    },
  );
}

export function addNewUser(data: any) {
  return axios.post(`${baseUrl}/user`, data);
}

export function verifySms(data: { pin: string; pinId: string; token: string }) {
  return axios.post(`${baseUrl}/user/verifyPinSmsing`, data);
}

export async function getProfileSettingsInfoApi(login: string) {
  return axiosInstance.get(`/user/settings/profil/getInfos`, {
    params: { login },
  });
}

export function updateProfileSettingsInfoAPI(data: any) {
  return axiosInstance.post('/user/settings/profil/editProfile', data);
}

export function getUserInfoAPI() {
  return axiosInstance.get('/user/decode-token');
}
export function verifySmsEpargnUnvalidUser(data: {
  pin: string;
  pinId: string;
  token: string;
}) {
  return axios.post(`${baseUrl}/user/verifyPinSmsingEpargn`, data);
}

export function sendEmailSubscription(data: EmailSubsciptionType) {
  return axios.post(
    `${baseUrl}/user/send-email-verification-subscription`,
    data,
  );
}

export function verifyEmail(data: EmailVerificationType) {
  return axios.post(`${baseUrl}/user/verify-email-code-subscription`, data);
}
export function verifyIdentityAPI() {
  return axiosInstance.post('/send-SMS');
}
